export default {
  modalContent: {
    width: '600px'
  }
}
